import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class ChallengeTaskService {
    static getChallengeTasks(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`challenge-tasks?filter=${qs}`, pageNumber));
    }
    static fetchChallengeTask(oid) {
        return lastValueFrom(BaseService.get(`challenge-tasks/${oid}`));
    }
    static saveChallengeTask(dto) {
        return lastValueFrom(BaseService.save(`challenge-tasks`, dto));
    }
    static deleteChallengeTask(oid) {
        return lastValueFrom(BaseService.delete(`challenge-tasks/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Download sample file
    // ----------------------------------------------------------------------
    static downloadChallengeTaskSample(taskId, fileType, fileName) {
        BaseService.downloadFile(`challenge-tasks-sample-download/${fileType}/${taskId}`, fileName, null);
    }
}
